/* eslint-disable global-require */

module.exports = {
  VISUALISATION: {
    area: require('../styles/img/icon-128-visualisation-area.png'),
    bar: require('../styles/img/icon-128-visualisation-bar.png'),
    bubble: require('../styles/img/icon-128-visualisation-bubble.png'),
    donut: require('../styles/img/icon-128-visualisation-donut.png'),
    line: require('../styles/img/icon-128-visualisation-line.png'),
    map: require('../styles/img/icon-128-visualisation-map.png'),
    pie: require('../styles/img/icon-128-visualisation-pie.png'),
    'pivot table': require('../styles/img/icon-128-visualisation-pivot-table.png'),
    polararea: require('../styles/img/icon-128-visualisation-polararea.png'),
    scatter: require('../styles/img/icon-128-visualisation-scatter.png'),
  },
  LIBRARY_LISTING: {
    dashboard: require('../styles/img/icon-256-library-listing-dashboard.png'),
    dataset: require('../styles/img/icon-256-library-listing-dataset.png'),
    raster: require('../styles/img/icon-256-library-listing-raster.png'),
    visualisation: require('../styles/img/icon-256-library-listing-visualisation.png'),
  },
  BRAND: {
    logo: 'https://akvo-public.storage.googleapis.com/AkvoLogo.svg',
  },
  DATASET: {
    text: require('../styles/img/type-text.svg'),
    number: require('../styles/img/type-number.svg'),
    date: require('../styles/img/type-date.svg'),
    geopoint: require('../styles/img/type-geopoint.svg'),
    geoshape: require('../styles/img/type-geoshape.svg'),
    multiple: require('../styles/img/type-multiple.svg'),
    option: require('../styles/img/type-option.svg'),
  },

};



// WEBPACK FOOTER //
// ./src/constants/images.js